import { stopSharedCoreSession } from '@/core/kmp/shared-core-session'
import { appConfig } from '@/shared/config/app-config'

/**
 * Clear all per-user localStorage data on logout.
 * Keeps: language, deviceID, onboarding status, plan progress
 * (all persisted per userId).
 */
export function clearUserData() {
  localStorage.removeItem(`${appConfig.storagePrefix}_app_banner_link`)
  // The next session starts a fresh shared graph, with nothing cached from this user.
  stopSharedCoreSession()
}
